export default {
  Irrf: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "irrf"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Irrf.js
// module id = Bxpa
// module chunks = 18